import * as productApi from '../../api/product-api';
import { IProductSearchResponse } from '../../models/product-list';
import { IErrorResult, IResult } from '../../models/result-models';
import { apiCallError, beginApiCall } from '../api/api-status-action';

export const LOAD_PRODUCTS_SUCCESS = 'LOAD_PRODUCTS_SUCCESS';
export const LOAD_PRODUCTS_ERROR = 'LOAD_PRODUCTS_ERROR';

export const loadProductsSuccess = (
    payload: IResult<IProductSearchResponse>
) => ({
    type: LOAD_PRODUCTS_SUCCESS,
    payload,
});

export const loadProductsError = (payload: IErrorResult) => ({
    type: LOAD_PRODUCTS_ERROR,
    payload,
});

// Thunks
export const loadProducts = (
    categoryId: string | null,
    categoryName: string | null,
    query: string | null,
    attributeValueIds: string | null,
    attributeDefinitions: string | null,
    isCustom: boolean,
    pageNumber: number
) => {
    return async (dispatch: any) => {
        try {
            dispatch(beginApiCall());
            const result = await productApi.getProducts(
                categoryId,
                categoryName,
                query,
                attributeValueIds,
                attributeDefinitions,
                isCustom,
                pageNumber
            );
            if (result.ok) {
                dispatch(loadProductsSuccess(result));
            } else {
                dispatch(
                    loadProductsError({
                        errorMessage: result.message,
                        modelErrors: result.errors,
                    })
                );
            }
        } catch (error) {
            dispatch(apiCallError(error));
            throw error;
        }
    };
};
